<template>
  <!-- 상품 시간 / 위치 정보 -->
  <div style="margin-bottom: 1.5rem">
    <div class="box tab-item">
      <admin-box-item
        title="위치">
        <div class="columns is-multiline">
          <!-- 상품 위치 정보 -->
          <div class="column is-full">
            <admin-form-item label="상품위치"
                            desc="파트너의 주소와 다른 경우 별도로 입력하면 해당상품은 상품위치 기반으로 유저에게 노출됩니다."
                            :notRequired="true">
              <lp-address :data.sync="prod.address"></lp-address>
              <block-negative v-if="locationCheck"
                              :notTxt="notTxt"
                              button="지도 설정하기"
                              @clicked="routeAccount"></block-negative>
              <div class="position-relative" v-if="!locationCheck">
                <div id="naver-map"></div>
                <!--<img src="/static/icon/ic_pin.svg" alt="pin" class="map-pin">-->
              </div>
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import LpAddress from "../../../module/common/LpAddress";
  import BlockNegative from "./BlockNegative";
  export default {
    name: "PanelProductLocation",
    components: {
      BlockNegative,
      LpAddress
    },
    props: {
      prod: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        notTxt: '주소의 위치 정보가 설정되어 있지 않습니다.\n위치 정보를 사용하는 서비스에서는 서비스관리 > 연동계정관리에서 네이버지도를 사용설정하고 다시 저장해주세요.',
        map: undefined,
        marker: undefined
      }
    },

    created() {
      this.setNaverMap();
    },

    watch: {
      'prod.address': {
        handler(n) {
          this.setNaverMap();
        },
        deep: true
      }
    },
    computed: {
      locationCheck () {
        let lt = this.prod.address.latitude;
        let ln = this.prod.address.longitude;
        // let result = (lt === 32 && ln === 127) ||
        //        (lt === '' && ln === '') ||
        //        (!lt && !ln);
        let naver = this.$store.getters.getServiceSetting.social_key.naver;
        let result = !naver.enable.map || (naver.enable.map && naver.map.client_id === '' && naver.map.client_secret === '')
        return result;
      }
    },
    methods: {
      routeAccount() {
        const a = document.createElement('a');
        a.href = '/office/admin/service/account';
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
      },
      setNaverMap() {
        if(!this.locationCheck) {
          if(this.map) {
            this.setMapCenter();
          } else {
            let naverMap = this.$store.getters.getServiceSetting.social_key.naver.map.client_id;
            if(naverMap !== '') {
              let head = document.getElementsByTagName('head')[0];
              for (let c of head.children) {
                if (c.src && c.src.indexOf('openapi.map.naver') > -1) {
                  head.removeChild(c)
                }
              }

              let el = document.createElement('script');
              el.setAttribute('type', 'text/javascript');
              el.setAttribute('src', `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${naverMap}&submodules=geocoder`);
              head.appendChild(el);
            }
            setTimeout(()=> {
              this.setMapView();
            }, 1000);
          }
        }
      },
      setMapView() {
        this.map = new naver.maps.Map('naver-map', {
          mapTypeId: naver.maps.MapTypeId.NORMAL
        });
        this.map.setZoom(18);
        this.map.setOptions({
          zoomControl: true
        });
        this.setMapCenter();
      },
      setMapCenter() {
        let lt = this.prod.address.latitude;
        let ln = this.prod.address.longitude;
        let pos = new naver.maps.LatLng(Number(lt), Number(ln));
        this.map.setCenter(pos);
        if(this.marker) {
          this.marker.setMap(null);
        }
        this.marker = new naver.maps.Marker({
          position: pos,
          map: this.map,
          icon: {
            url: '/static/icon/ic_pin.svg',
            size: new naver.maps.Size(27, 38),
            origin: new naver.maps.Point(0, 0),
            anchor: new naver.maps.Point(14, 38)
          }
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  #naver-map
    width 100%
    height 234px
  .map-pin
    position absolute
    left calc(50% - 14px)
    top calc(50% - 38px)
</style>
